export const PRIME_VIDEO_OBJECT = {
  production: {
    PRIME_MOVIE_JSTREAM_CONTRACT_ID: 'MTg4MA==',
    PRIME_MOVIE_JSTREAM_PLAYER_URL:
      'eqb503auub.eq.webcdn.stream.ne.jp/www50/eqb503auub/jmc_pub/jmc_swf/player/',
    PRIME_MOVIE_JSTREAM_PLAYER_JS_URL:
      'https://ssl-cache.stream.ne.jp/www50/eqb503auub/jmc_pub/jmc_swf/player/t3/if.js',
  },
  stage: {
    PRIME_MOVIE_JSTREAM_CONTRACT_ID: 'Nzc3OA==',
    PRIME_MOVIE_JSTREAM_PLAYER_URL:
      'eqh883chhh.eq.webcdn.stream.ne.jp/www50/eqh883chhh/jmc_pub/jmc_swf/player/',
    PRIME_MOVIE_JSTREAM_PLAYER_JS_URL:
      'https://ssl-cache.stream.ne.jp/www50/eqh883chhh/jmc_pub/jmc_swf/player/t3/if.js',
  },
};
